import React from 'react'

import Icon from '../shapes/Icon'

const SortIndicator = ({ active, type }) => {
  if (!active) return false
  const name = type === 'ASC' ? 'BsFillCaretUpFill' : 'BsFillCaretDownFill'
  return <Icon name={name} size={0.7} color="dark3" />
}

export default SortIndicator
